import { ProjectAssignment } from "../projects";
import { IConverter, TSnapshot } from "./generics";

export const projectAssignmentConverter: IConverter<ProjectAssignment> =
  {
    toFirestore(assignment: ProjectAssignment) {
      const { id, clientName, projectName, ...data } = assignment;
      return data;
    },
    fromFirestore(snapshot: TSnapshot): ProjectAssignment {
      const data = snapshot.data();
      return {
        ...data,
        id: snapshot.id,
        clientId: data?.clientId || "",
        projectId: data?.projectId || "",
        clientName: data?.clientName,
        projectName: data?.projectName,
        status: data?.status || "",
        startDate: data?.startDate || "",
        endDate: data?.endDate || "",
        billableRate: data?.billableRate || 0,
        engineerId: data?.engineerId || "",
        csaId: data?.csaId || null,
        budgetedHours: data?.budgetedHours,
        everSignDocumentStatus: data?.everSignDocumentStatus,
        isUploadedToStorage: data?.isUploadedToStorage,
      };
    },
  };
